import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import {
    createRequestCacheKey,
    fetchWithCache,
    invalidateRequestCache,
} from '../helpers/requestCache';
import { collectMediaUrls, preloadMediaUrls } from '../helpers/mediaPreloader';

const CHAT_MESSAGES_TTL_MS = 20 * 1000;

const chatMessagesCacheKey = (classId) => createRequestCacheKey('chat', 'messages', classId);

export const chatService = {
    fetchChatMessages,
    sendChatMessage,
    reportChatMessage
};

function fetchChatMessages(classId) {
    return fetchWithCache({
        key: chatMessagesCacheKey(classId),
        ttlMs: CHAT_MESSAGES_TTL_MS,
        persistToSession: false,
        loader: () => apiClient.get(`${api.chatmessage.fetchChat}/${classId}`)
            .then(handleResponse)
            .then(data => {
                const messages = data?.data ?? data ?? [];
                preloadMediaUrls(collectMediaUrls(messages, ['SenderProfileImage']));
                return data;
            }),
    })
        .catch(error => handleError(error.response));
}

function sendChatMessage(msg) {
    return apiClient.post(api.chatmessage.sendChat, msg)
        .then(handleResponse)
        .then(data => {
            invalidateRequestCache(createRequestCacheKey('chat', 'messages'));
            return data;
        })
        .catch(error => handleError(error.response));
}

function reportChatMessage(reportMsg) {
    return apiClient.post(api.chatmonitoring.reportChat, reportMsg)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}
